//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../no/Builder.js";
import "../Diagramming/Diagramming.AnnotationBuilder.js";
import "../Diagramming/Diagramming.LeaderLineBuilderList.js";
import "../no/ObjectList.js";
let d=[[[1,"AnnotationBuilder",0,"Diagramming.AnnotationBuilder",0],[1,"LeaderLines",0,"Diagramming.LeaderLineBuilderList",0],[0,"TextBoxIndent",1,0],[0,"TextBoxModifiable",1,0],[0,"TextBoxShadowBox",1,0]],[[[],"CreateLeaderLine",{R_:{leaderLine:"Diagramming.LeaderLineBuilder"}},0,0],[["inheritOption","annotation"],"Inherit",{},2,0]],[]];
SPLM.Diagramming.CannedAnnotationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.CannedAnnotationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Diagramming.CannedAnnotationBuilder.InheritOption = Object.freeze({
    "Preferences" : "Preferences", "CustomerDefaults" : "CustomerDefaults", "Selection" : "Selection"});

export default SPLM;